module.exports = __webpack_public_path__ + "static/img/victim-teens-7.ed7e3ed6.png";